import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters(["idWorldOutgo"]),
    getByProject: state => idProject => {
      return state.objs.filter(
        outgo => outgo.referencingProject === idProject
      );
    },
    getByUser: state => idUser => {
      return state.objs.filter(
        outgo => outgo.user === idUser
      );
    },
  },
  mutations: {
    ...functions.createDefaultMutations(["idWorldOutgo"]),
    deleteByProject: (state, idProject) => {
      state.objs.forEach((outgo, index) => {
        if ((outgo.referencingProject = idProject)) {
          state.objs.splice(index, 1);
        }
      });
    }
  },
  actions: {
    ...functions.createDefaultActionsWithStore(['idWorldOutgo']),
    deleteByProject: ({ commit }, idProject) => {
      return new Promise(resolve => {
        commit("deleteByProject", idProject);
        resolve();
      });
    }
  }
};
